import { render, staticRenderFns } from "./UsersItem.vue?vue&type=template&id=5d500321&"
import script from "./UsersItem.vue?vue&type=script&lang=ts&"
export * from "./UsersItem.vue?vue&type=script&lang=ts&"
import style0 from "./UsersItem.vue?vue&type=style&index=0&id=5d500321&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports